const TASK_STATUSES = ['todo', 'inProgress', 'completed'] as const;

export type TaskStatus = (typeof TASK_STATUSES)[number];

export interface Task {
  name: string;
  description?: string | null;
  status: TaskStatus;
  internalUserId?: string | null;
  clientId?: string | null;
  companyId?: string | null;
  dueDate?: string;
}

export function isTask(
  data?: any,
  strictAssigneeValidation: boolean = true,
): data is Task {
  const hasRequiredFields =
    data &&
    typeof data.name === 'string' &&
    typeof data.status === 'string' &&
    TASK_STATUSES.includes(data.status);

  if (!hasRequiredFields) return false;

  const { description, dueDate, internalUserId, clientId, companyId } = data;

  // Validate that optional fields are strings when present
  if (description !== undefined && typeof description !== 'string')
    return false;
  if (dueDate !== undefined && typeof dueDate !== 'string') return false;
  if (internalUserId !== undefined && typeof internalUserId !== 'string')
    return false;
  if (clientId !== undefined && typeof clientId !== 'string') return false;
  if (companyId !== undefined && typeof companyId !== 'string') return false;

  if (strictAssigneeValidation) {
    // Check valid combinations:
    // 1. internalUserId provided, clientId and companyId undefined
    const isInternalUser =
      internalUserId !== undefined &&
      clientId === undefined &&
      companyId === undefined;
    // 2. only companyId provided
    const isCompanyOnly =
      companyId !== undefined &&
      clientId === undefined &&
      internalUserId === undefined;
    // 3. companyId and clientId provided, internalUserId undefined
    const isCompanyClient =
      companyId !== undefined &&
      clientId !== undefined &&
      internalUserId === undefined;

    return isInternalUser || isCompanyOnly || isCompanyClient;
  } else {
    return true;
  }
}
